module.exports = __webpack_public_path__ + "img/pin_grey_camion.e7ec6919.svg";